import React from 'react';

import { useTranslation } from 'react-i18next';

import { Sheet } from '@pkg/components';

import { Unsupported } from './components';

import { NftCount, Title } from './styles';

type PanelHeaderProps = {
    total: number;
    isSearch?: boolean;
};
export function PanelHeader({ total, isSearch }: PanelHeaderProps) {
    const [translate] = useTranslation(['yat_nft_manager']);

    const titleMarkup = (
        <>
            {translate('yat_nft_manager_your_nfts')}
            <NftCount>({total})</NftCount>
        </>
    );

    const searchTitleMarkup = translate('yat_nft_manager_results_header', { amount: total }) + (total !== 1 ? 's' : '');

    return (
        <Sheet.Layout.Columns stretch>
            <Sheet.Layout.Columns.Primary>
                <Title>{isSearch ? searchTitleMarkup : titleMarkup}</Title>
            </Sheet.Layout.Columns.Primary>

            <Unsupported />
        </Sheet.Layout.Columns>
    );
}
